/**
 * @fileoverview Vuex module for Watson Assistant (IBM Watson) integration.
 *
 * @module store/modules/watson
 *
 * Combines actions, getters, mutations, and state for Watson Assistant
 * features including intents, entities, examples, and dialog management.
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { WatsonState } from "./types";
import { RootState } from "@/store/types";

const watson: Module<WatsonState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default watson;
